export function getPathWithSlash(path) {
    const pathSlash = path ? '/' : '';
    return `${path}${pathSlash}`;
}